import type { Camera, Scene } from 'three';
import type { PresetEffect, PresetEffectFactory } from './types';
import { NebulaEffect } from './NebulaEffect';

const registry: Record<string, PresetEffectFactory> = {
  nebula: () => new NebulaEffect(),
};

export class EffectManager {
  private current: PresetEffect | null = null;
  private currentName: string | null = null;
  private scene: Scene;
  private camera: Camera;

  constructor(scene: Scene, camera: Camera) {
    this.scene = scene;
    this.camera = camera;
  }

  activate(presetName: string): void {
    if (this.currentName === presetName) return;
    this.deactivate();
    const factory = registry[presetName];
    if (!factory) return;
    this.current = factory();
    this.current.setup(this.scene, this.camera);
    this.currentName = presetName;
  }

  deactivate(): void {
    if (this.current) {
      this.current.dispose();
      this.current = null;
      this.currentName = null;
    }
  }

  update(delta: number, elapsed: number): void {
    this.current?.update(delta, elapsed);
  }

  dispose(): void {
    this.deactivate();
  }
}
